"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeTrialActions = void 0;
exports.freeTrialActions = {
    /* MOB_USER */
    FETCH_MOB_USER: true,
    CREATE_MOB_USER: true,
    EDIT_MOB_USER: true,
    DELETE_MOB_USER: true,
    /* WEB_USER */
    FETCH_WEB_USER: true,
    CREATE_WEB_USER: true,
    EDIT_WEB_USER: true,
    DELETE_WEB_USER: true,
    /* TEAM */
    FETCH_TEAM: true,
    CREATE_TEAM: true,
    EDIT_TEAM: true,
    DELETE_TEAM: true,
    ADVANCED_ACTION_TEAM: true, // assign users to teams
    /* WORKFLOW */
    FETCH_WORKFLOW: true,
    /* ALL REPORTS (WORKFLOWS, ACTIVITIES, ...) */
    FETCH_ACTIVITY_REPORT: true,
    /* LIST */
    FETCH_LIST: true,
    EDIT_LIST: true,
    /* ITEM */
    FETCH_ITEM: true,
    CREATE_ITEM: true,
    EDIT_ITEM: true,
    DELETE_ITEM: true,
    /* TERRITORY */
    FETCH_TERRITORY: true,
    /* DASHBOARD */
    FETCH_DASHBOARD: true,
    EXPORT_CLIENT_DATA: true,
    VIEW_DEFAULT_DASHBOARDS: true,
    /* PICTURE */
    FETCH_CLIENT_PICTURE: true,
    /* DOCUMENT */
    FETCH_DOCUMENT: true,
    CREATE_DOCUMENT: true,
    DELETE_DOCUMENT: true,
    /* CLIENT SETTINGS */
    FETCH_CLIENT_SETTINGS: true,
    EDIT_CLIENT_SETTINGS: true,
};
